import { Component, OnInit, ViewContainerRef, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { ResultSigningDataService } from '../../data-services/resultsigning.service';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { RequisitionTestDataService } from '../../data-services/requisitionTest.service';
import moment from 'moment';
import { CodeDescription } from '../../models/code-description-dto';
import { Gender } from '../../models/gender';
import { Ethnicity } from '../../models/ethnicity';
import { SecurityService } from '../../security/security.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { KENDO_DATEINPUTS } from "@progress/kendo-angular-dateinputs";
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import { ReactiveFormsModule } from '@angular/forms'; // Import ReactiveFormsModule
import { ConfigService } from '../../configHelper';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-sign-results-test',
  templateUrl: './signResults.test.html',
  providers: [MessageService, ConfirmationService],
  imports: [ConfirmDialog, Dialog, FormsModule, Toast, CommonModule, KENDO_DATEINPUTS, KENDO_DROPDOWNS, ReactiveFormsModule]
})
export class SignResultsTestComponent implements OnInit {
  @Output() onSaveTest = new EventEmitter();
  constructor(private signingService: ResultSigningDataService,
    private requisitionTestService: RequisitionTestDataService,
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
    private domSanitizer: DomSanitizer,
    public dialogModule: DialogModule,
    public securityService: SecurityService,
    private configService: ConfigService) {
  }

  @ViewChild('container', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;


  @Input() requisitionTestId: any = 28;

  loading: boolean = true;
  inEdit: boolean = false;
  test: any = {};
  pdfContent: Uint8Array;
  pdfView: any = null;

  genderList: CodeDescription[] = [];
  genderDto: Gender;
  genderDescription: string;

  ethnicityList: CodeDescription[] = [];
  ethnicity: Ethnicity;
  ethnicityDescription: string;

  minbdate: Date;
  maxbdate: Date;
  formattedminbdate: string;
  formattedmaxbdate: string;
  requisitionEditForm: UntypedFormGroup;
  isInterVenn: boolean = false;
  showResultComment: boolean = false;
  resultIdForComment: number;
  resultComment: string;

  ngOnInit() {
    this.isInterVenn = this.configService.getConfig().isInterVenn;
    this.minbdate = new Date();
    this.minbdate.setFullYear(this.minbdate.getFullYear() - 120);
    this.formattedminbdate = moment(this.minbdate).format('MM/DD/YYYY')
    this.maxbdate = new Date();
    this.formattedmaxbdate = moment(this.maxbdate).format('MM/DD/YYYY')

    this.genderDto = new Gender();
    this.genderList = this.genderDto.getGenderListing();

    this.ethnicity = new Ethnicity();
    this.ethnicityList = this.ethnicity.getEthnicityListing();

    this.loadTest();

    this.setFormGroup();
  }

  public loadTest() {
    this.signingService.getTestInfo(this.requisitionTestId).subscribe((data: any) => {
      this.test = data;

      this.genderDescription = this.genderList.find(x => {
        return (x.Code == this.test.PatientGender);
      })?.Description;

      this.ethnicityDescription = this.ethnicityList.find(x => {
        return (x.Code == this.test.PatientEthnicity);
      })?.Description;

      let birthdate = this.test.PatientBirthdate == null ? null : this.test.PatientBirthdate;
      let bdate: Date = null;
      if (birthdate !== null) {
        bdate = moment(birthdate).toDate();
        this.requisitionEditForm.get('birthDate').setValue(bdate);
      } else {
        this.requisitionEditForm.get('birthDate').setValue("");
      }
      this.requisitionEditForm.get('gender').setValue(this.test.PatientGender);
      this.requisitionEditForm.get('ethnicity').setValue(this.test.PatientEthnicity);
      this.requisitionEditForm.get('firstName').setValue(this.test.PatientFirstName);
      this.requisitionEditForm.get('lastName').setValue(this.test.PatientLastName);
      this.requisitionEditForm.get('mrn').setValue(this.test.PatientMRN);

      console.log('test', data);
      this.loading = false;
    });
  }

  setFormGroup() {
    this.requisitionEditForm = this.formBuilder.group({
      firstName: ['', [Validators.required, this.nowhitespace]],
      lastName: ['', [Validators.required, this.nowhitespace]],
      birthDate: ['', [Validators.required, this.checkMinBirthDate(), this.checkMaxBirthDate()]],
      gender: [''],
      ethnicity: [''],
      mrn: [''],
      comment: ['', [Validators.required]]
    });
  }
  public getRequisitionTestResultReport(resultId) {
    this.requisitionTestService.getTestResultReport(resultId).subscribe((response: any) => {
      if (response) {
        let file = new Blob([response], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        this.pdfView = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
        //window.open(fileURL);
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve Report PDF ', detail: 'Failed: ' + err.error });
    });
  }

  setResultComment(rid, comment) {
    this.resultIdForComment = rid;
    this.resultComment = comment;
    this.showResultComment = true;
  }

  saveResultComment() {
    this.requisitionTestService.setResultComment(this.resultIdForComment, this.resultComment).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Comment Saved', detail: `Successful` });
      this.showResultComment = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Comment Save Failed', detail: err.error });
      this.showResultComment = false;
    });
  }

  public editTest() {
    this.inEdit = true;
  }

  public cancelEdit() {
    this.inEdit = false;
  }

  public saveEdit() {

    if (!this.requisitionEditForm.valid) {
      this.messageService.add({ severity: 'error', summary: 'Please provide valid values for all required fields ' });
      return;
    }

    this.loading = true;
    this.test.PatientFirstName = this.requisitionEditForm.get('firstName').value;
    this.test.PatientLastName = this.requisitionEditForm.get('lastName').value;
    this.test.PatientBirthdate = this.requisitionEditForm.get('birthDate').value;
    this.test.PatientGender = this.requisitionEditForm.get('gender').value;
    this.test.PatientEthnicity = this.requisitionEditForm.get('ethnicity').value;
    this.test.PatientMRN = this.requisitionEditForm.get('mrn').value;
    this.test.EditComment = this.requisitionEditForm.get('comment').value;

    this.signingService.updateTestInfo(this.test).subscribe((data: any) => {
      this.cancelEdit();
      this.onSaveTest.emit();
      this.loading = false;
    });

  }

  nowhitespace(control: AbstractControl): ValidationErrors | null {
    let str = control.value as string;
    if (str === null) return null;
    if (str.length >= 0 && str.startsWith(' ')) {
      return { nowhitespace: true }
    }
    return null;
  }

  checkMinBirthDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      if (value < this.minbdate) {
        return { minBirthDate: true };
      } else return null;
    }
  }

  checkMaxBirthDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      if (value > this.maxbdate) {
        return { maxBirthDate: true };
      } else return null;
    }
  }
}


